import { FaIcon } from '@/lib/fa'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import * as React from 'react'

const StageHeader = ({ title, icon , textSize = 'lg'}: { title: string; icon?: IconProp, textSize?: 'sm'  | 'lg' }) => {
  return (
    <div className="tw-flex tw-flex-1 tw-items-start tw-gap-2">
      {icon && <FaIcon icon={icon} className='tw-max-w-3'/>}
      <p className={`tw-m-0 tw-text-${textSize} tw-font-semibold tw-text-content-base`}>
        {title}
      </p>
    </div>
  )
}

export default StageHeader
